import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import TextInput from '../../core/TextInput';
import TextAreaInput from '../../core/TextAreaInput';

interface ConnectionDetailsSectionLocalProps {
    connectionData?: {
        host: string;
        username: string;
        sshKey: string;
        directoryPath: string;
    } | null;
}

type ConnectionDetailsSectionProps = ConnectionDetailsSectionLocalProps & ToxnotComponentProperties;

class ConnectionDetailsSectionComponent extends ToxnotComponent<ConnectionDetailsSectionProps> {
    public render() {
        const { connectionData } = this.props;

        return (
            <>
                <div className="alert alert-danger" style={{ fontWeight: 'bold' }}>
                    {this.localizeString("Please do not share this information with anyone outside of your IT team or those responsible for data management within your organization.")}
                </div>
                <div className="group">
                    <div className="title">{this.localizeString("Connection")}</div>
                    <div className="content">
                        <div className="form-group">
                            <label>{this.localizeString("Host")}</label>
                            <TextInput value={connectionData?.host || this.localizeString('Loading...')} onValueChange={() => { }} disabled />
                        </div>
                        <div className="form-group">
                            <label>{this.localizeString("Username")}</label>
                            <TextInput value={connectionData?.username || this.localizeString('Loading...')} onValueChange={() => { }} disabled />
                        </div>
                    </div>
                </div>
                <div className="group">
                    <div className="title">{this.localizeString("Authentication Method")}</div>
                    <div className="content">
                        <div className="form-group">
                            <label>{this.localizeString("SSH Key")}</label>
                            <TextAreaInput value={connectionData?.sshKey || this.localizeString('Loading...')} onValueChange={() => { }} disabled rows={5} />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export const ConnectionDetailsSection = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ConnectionDetailsSectionComponent);
